import { ConceptModelWorkerProxy } from './concept-model-worker-proxy';
import { loadWorker } from './worker-loader';

export class ConceptModelWorkerWrapper {
  private readonly worker: Worker | null;
  private readonly onMessage: (event: MessageEvent) => void | null;

  /**
   * Wrapper for ConceptModel Processing. Unit-Tests will execute the same Code as the Worker, but inside the Main Event-Loop.
   */
  constructor(onMessage: (e: MessageEvent) => void) {
    if (typeof Worker !== 'undefined') {
      this.worker = loadWorker();
      this.worker.onmessage = onMessage;
    } else {
      this.onMessage = onMessage;
    }
  }

  /**
   * Proxy for either the worker method or the same method inside the current event loop.
   */
  public postMessage(data: any) {
    if (this.worker) {
      this.worker.postMessage(data);
    } else {
      //
      const postMessageFn = (data: any) => {
        this.onMessage({ data: data } as MessageEvent);
      };

      let conceptModelExecutor: (event: MessageEvent) => void;
      ConceptModelWorkerProxy.proxy((type: string, handler: (event: MessageEvent) => void) => {
        conceptModelExecutor = handler;
      }, postMessageFn);

      conceptModelExecutor({ data: data } as MessageEvent);
    }
  }
}
